<template>
  <v-footer color="red darken-4" class="mt-5" dark padless>
    <v-row justify="center" no-gutters>
      <v-col class="red darkem-4 py-4 text-center white--text" cols="12">
        {{ new Date().getFullYear() }} — <strong>AngularRank</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {};
</script>

<style></style>
